import { render } from "./fb-vog-write-icon.svg?vue&type=template&id=7cc195aa"
const script = {}
script.render = render

export default script